<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headerloi01" class="chapter" epub:type="frontmatter" id="loi">
<header id="headerloi01">
<h1 class="ctfm"><span aria-label=" Page x. " class="page" epub:type="pagebreak" id="px" role="doc-pagebreak"></span><span aria-label=" Page xi. " class="page" epub:type="pagebreak" id="pxi" role="doc-pagebreak"></span><a class="xref" href="#/chiFischerOA0007#toc">Illustrations</a></h1>
</header>
<p class="tocill"><a class="xref" href="#/chiFischerOA0009#fig1">1  Jane Addams, scientist, 1940</a></p>
<p class="tocill"><a class="xref" href="#/chiFischerOA0011#fig2">2  Mass meeting at Hull House, 1895</a></p>
<p class="tocill"><a class="xref" href="#/chiFischerOA0012#fig3">3  United States troops sent to Chicago, 1894</a></p>
<p class="tocill"><a class="xref" href="#/chiFischerOA0013#fig4">4  He Won’t Be Reformed, 1898</a></p>
<p class="tocill"><a class="xref" href="#/chiFischerOA0014#fig5">5  Hull House, Pond &amp; Pond, Architects, 1900</a></p>
<p class="tocill"><a class="xref" href="#/chiFischerOA0015#fig6">6  Free lectures on organic evolution, 1897</a></p>
<p class="tocill"><a class="xref" href="#/chiFischerOA0016#fig7">7  Jane Addams in NCR Women’s Dining Room, May 1898</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Fischer-OA-0008.vue?d99c0f42